import {Button, Slider, Typography, theme} from 'antd';
import {GiftOutlined, MinusCircleOutlined, PlusCircleOutlined} from '@ant-design/icons';
import OTPInput from './CreditCardInput';

import React, {useEffect, useMemo, useState} from 'react';
import styles from './../styles';
import {useSelector} from 'react-redux';
interface IBuyGiftCardProps {
  min: number;
  max: number;
  buyOffer: Function;
  loginData: any;
  giftCardType: string;
  error?: string;
  clearError: () => void;
}

const getStaticValues = (startingAmount: number): number[] => {
  return startingAmount < 25 ? [startingAmount, 25, 50, 75] : [startingAmount, 50, 75, 100];
};

function BuyGiftCard(props: IBuyGiftCardProps) {
  const {token} = theme.useToken();
  const agentUserName = useSelector((state: any) => state?.login?.userName);
  const memberAccountInfo = useSelector((state: any) => state?.gmMemmberRewardsInfo);
  const MAXIMUM_RANGE = props.max ? props.max : 75;
  const MINIMUM_RANGE = props.min ? props.min : 15;

  const [amount, setAmount] = useState(MINIMUM_RANGE);
  const [loading, setLoading] = useState(false);
  const [ccDigits, setCcDigits] = useState('');

  const staticValuesArray = getStaticValues(MINIMUM_RANGE);
  const SLIDER_STEP = 5;
  const quantity = 1;

  useEffect(() => {
    setLoading(false);
  }, [props.error]);

  const handleChange = (newValue: number) => {
    props.clearError();
    setAmount(newValue);
  };

  const redeemableDollars = memberAccountInfo?.data?.memberAccountInfo?.redeemableDollars;
  const buyNowEnabled =
    props.giftCardType !== 'Plastic' && ccDigits.length >= 4 && amount <= redeemableDollars;

  const sliderProps = useMemo(
    () => ({
      min: MINIMUM_RANGE,
      max: MAXIMUM_RANGE,
      value: amount,
      step: SLIDER_STEP,
      onChange: (v: number) => handleChange(v),
    }),
    [MAXIMUM_RANGE, MINIMUM_RANGE, amount, handleChange],
  );

  const generateStaticValues = (): any => {
    return Array.apply(1, Array(staticValuesArray.length)).map((x: any, index: number) => {
      const value = staticValuesArray[index];
      const isSelected = value === amount;
      const color = isSelected ? token.colorPrimary : token.colorBgContainer;
      const textColor = isSelected ? token.colorTextLightSolid : token.colorTextBase;
      return (
        <div
          key={index}
          onClick={() => selectValidAmount(value)}
          style={{...styles.pricing_table_col, backgroundColor: color, color: textColor}}>
          ${value}
        </div>
      );
    });
  };
  const selectValidAmount = (selectedAmount: number) => {
    props.clearError();
    selectedAmount <= MINIMUM_RANGE ? setAmount(MINIMUM_RANGE) : setAmount(selectedAmount);
  };
  return (
    <div style={{textAlign: 'center', paddingLeft: 20}}>
      <Typography.Text strong>Select your amount</Typography.Text>

      <div style={styles.pricing_table}>{generateStaticValues()}</div>

      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <Button
          type="text"
          shape="circle"
          size="large"
          icon={<MinusCircleOutlined style={{fontSize: 28}} />}
          onClick={() => {
            props.clearError();
            amount <= MINIMUM_RANGE ? setAmount(MINIMUM_RANGE) : setAmount(amount - MINIMUM_RANGE);
          }}
          disabled={amount <= MINIMUM_RANGE ? true : false}
        />
        <div style={{alignItems: 'center', fontWeight: 'bold', marginTop: 15}}>{amount}</div>
        <Button
          type="text"
          shape="circle"
          size="large"
          icon={<PlusCircleOutlined style={{fontSize: 28}} />}
          disabled={amount === MAXIMUM_RANGE ? true : false}
          onClick={() => {
            props.clearError();
            setAmount(amount + MINIMUM_RANGE);
          }}
        />
      </div>
      <div style={{marginBottom: 20, paddingLeft: 30}}>
        <Slider tooltip={{open: undefined}} {...sliderProps} />
      </div>
      <div style={{marginBottom: 32}}>
        <div style={{marginBottom: 32}}>
          For security purposes, please enter the last four digits of the Rewards card.
        </div>
        <div style={{paddingLeft: 20}}>
          <OTPInput
            autoFocus
            isNumberInput
            length={4}
            onChangeOTP={(otp) => {
              props.clearError();
              setCcDigits(otp.toString());
            }}
            inputClassName="otp_input"
            inputStyle={{border: `1px solid ${token.colorBorder}`}}
          />
        </div>
      </div>
      <Button
        loading={loading}
        onClick={() => {
          props.buyOffer(amount, quantity, ccDigits, agentUserName);
          setLoading(true);
        }}
        disabled={!buyNowEnabled}
        type="primary"
        icon={<GiftOutlined />}>
        Redeem Now
      </Button>

      <br />
      {amount > redeemableDollars && (
        <div style={{color: token.colorError}}>
          Selected amount is greater than available balance
        </div>
      )}
      {props.error && <div style={{color: token.colorError}}>{props.error}</div>}
    </div>
  );
}

export default BuyGiftCard;
